import React, { ReactNode } from "react";
import { Card, CardHeader, CardContent, CardFooter } from "./card";
import { Typography } from "./typography";
import Header from "../../layouts/Header";
import lockIcon from "../../assets/icons/lock.svg";
import eightIcon from "../../assets/images/80eight/88-footer.svg";

interface StackFormLayoutProps {
  title: string;
  onCancel?: () => void;
  showCancelHeader?: boolean;
  headerIcon?: string;
  maxWidth?: "max-w-2xl" | "max-w-3xl" | "max-w-4xl";
  cancelButtonText?: string;
  cancelButtonDisabled?: boolean;
  children: ReactNode;
}

const StackFormLayout: React.FC<StackFormLayoutProps> = ({
  title,
  onCancel,
  showCancelHeader = false,
  headerIcon,
  maxWidth = "max-w-3xl",
  cancelButtonText = "Cancel",
  cancelButtonDisabled = false,
  children,
}) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex items-center justify-center min-h-[calc(100vh-64px)] px-4 py-8">
        <Card
          className={`w-full ${maxWidth} shadow-xl border-gray-100 rounded-3xl overflow-hidden`}
        >
          {showCancelHeader && (
            <CardHeader className="flex-row justify-end px-6 pt-6 pb-0">
              <button
                onClick={onCancel}
                disabled={cancelButtonDisabled}
                className="text-pink-500 hover:text-pink-600 font-bold text-sm disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:text-pink-500"
              >
                {cancelButtonText}
              </button>
            </CardHeader>
          )}

          <CardContent className={`px-6 ${showCancelHeader ? "pt-2" : "pt-6"}`}>
            {headerIcon && (
              <div className="mb-2 flex justify-center">
                <img src={headerIcon} alt="header icon" />
              </div>
            )}

            <Typography
              variant="h2"
              className={`text-center ${headerIcon ? "mb-6" : "mb-8"}`}
            >
              {title}
            </Typography>

            {children}
          </CardContent>

          <CardFooter className="p-6 justify-center border-t border-gray-100">
            <div className="flex items-center justify-center space-x-2">
              <img src={lockIcon} alt="lock" />
              <Typography variant="p" className="text-gray-500">
                Secured by
              </Typography>
              <img src={eightIcon} alt="eight" />
            </div>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};

export default StackFormLayout;
